
<plugin-ui *ngIf="plugin && items" [plugin]="plugin" [context]="this"></plugin-ui>


<!-- <ul *ngIf="items" style="border:solid 4px yellow;">
    <li *ngFor="let item of items; let idx = index;" style="border:solid 4px white;padding:10px;margin:10px;">
        {{ idx + 1 }}. {{ item.name }} [{{ item.type }}]
    </li>
</ul> -->


<!-- <textarea style="width:100%;height:80px;font-size:8px;">{{ items | json }}</textarea> -->